import * as React from 'react';
import { cn } from '@/utils/utils';

interface EmptyStateProps {
  /** A glyph above the message, drawn h-6 w-6 in the faint colour. */
  icon?: React.ReactNode;
  title?: React.ReactNode;
  children?: React.ReactNode;
  /** What to do about it: a button or a text action. */
  action?: React.ReactNode;
  /** compact inside a panel or list, roomy on a page, inline as one line under a list's heading (a library section). */
  size?: 'compact' | 'roomy' | 'inline';
  className?: string;
}

/** What a list, panel or page says when there is nothing to show yet, and how to start; its message in the prose face. */
export function EmptyState({ icon, title, children, action, size = 'compact', className }: EmptyStateProps) {
  if (size === 'inline') return <p className={cn('font-lureo-font-prose text-lureo-13 leading-[1.4] text-lureo-ink-subtle', className)}>{children}</p>;
  return (
    <div className={cn('flex flex-col items-center gap-1.5 text-center font-lureo-font-ui', size === 'compact' ? 'py-6' : 'py-12', className)}>
      {icon && <span className="mb-1 text-lureo-ink-subtlest [&_svg]:h-6 [&_svg]:w-6">{icon}</span>}
      {title && <p className="text-lureo-14 font-medium text-lureo-ink">{title}</p>}
      {children && <p className="max-w-xs font-lureo-font-prose text-lureo-13 leading-[1.4] text-lureo-ink-subtle">{children}</p>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
